import React, { useState } from 'react';
import { useRouter } from '../hooks/useRouter';
import { resetPassword } from '../services/auth';
import { toast } from 'react-toastify';
import message from '../constant/message';
import { Context } from '../config/store';
import ReactTooltip from 'react-tooltip';
import PasswordPolicy from '../components/PasswordPolicy';
const ResetPassword = () => {
	const router = useRouter();
	const [password, setPassword] = React.useState('');
	const [confirm_password, setConfirmPassword] = React.useState('');
	const password_token = router.query.token;
	const [errors, setErrors] = React.useState(null);
	const { state } = React.useContext(Context);
	const [loader, setStatus] = React.useState(false);
	const [showPassword, setShowPassword] = useState(false)
	const [confshowPassword, SetconfshowPassword] = useState(false)

	const submitReset = async (e) => {
		setStatus(true);
		e.preventDefault();
		const response = await resetPassword({
			password,
			confirm_password,
			password_token,
			type: state.userType,
		});
		if (response?.status?.code === 1) {
			toast.success('Password reset successfully !');
			router.navigate(`/${state.userType}/login`);
		} else {
			let error = response.messages.error;
			toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
			setErrors(error);
		}
		setStatus(false);
	};
	let email;
	return (
		<>
			<section className='forget-password-container'>
				<div className='forget-user-bg'>
					<div className='logo text-center mb-2'>
						<img src='/images/logo.png' width={230} />
					</div>
					<div className='resetPassword mt-5'>
						<form>
							<div className='form-group'>
								<div className='d-flex align-items-center'>
									<label className='mr-1 mt-2' style={{ fontSize: '18px' }}>New Password</label><PasswordPolicy password={password} />
								</div>
								<div className='inputWithIcon'>
									<input
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										type={showPassword ? 'text' : 'password'}
										className='form-control'
										placeholder='***********'
										maxLength={25}
										style={{ height: '40px'}}
									/>
										<i onClick={() => setShowPassword(!showPassword)} className={`fa ${!showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
								</div>
								{errors && (
									<p className='mt-2 mb-0 text-danger'>
										{errors?.fields?.password?.[0]}
									</p>
								)}
							</div>
							<div className='form-group'>
								<div className='d-flex align-items-center mt-1'>
									<label className='mr-1' style={{ fontSize: '18px' }}>Confirm Password</label>
								</div>
								<div className='inputWithIcon'>
									<input
										value={confirm_password}
										onChange={(e) => setConfirmPassword(e.target.value)}
										type={confshowPassword ? 'text' : 'password'}
										className='form-control'
										placeholder='***********'
										maxLength={25}
										style={{ height: '40px' }}
									/>
									<i onClick={() => SetconfshowPassword(!confshowPassword)} className={`fa ${!confshowPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
								</div>
								{errors && (
									<p className='mt-2 mb-0 text-danger'>
										{errors?.fields?.confirm_password?.[0]}
									</p>
								)}
							</div>
							<div className="d-flex justify-content-center align-items-center mt-3">
								<div className='form-group'>
									<button
										style={{ height: "35px" }}
										disabled={loader}
										onClick={submitReset}
										className={`btn btn-blueButton hoverStyle d-flex justify-content-center'
										}`}
									>
										{loader ? <div className='loader' /> : 'Reset Password'}
									</button>
								</div>
							</div>
							{state.userType !== 'admin' && (
								<p className='text-center font-18 mb-0'>
									<a href='registration.html' className='text-orange'>
										<b>New Registration</b>
									</a>
								</p>
							)}
						</form>
					</div>
				</div>
			</section>
		</>
	);
};

export default ResetPassword;
